var _jsxFileName = "/codebuild/output/src2856833513/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/PasswordInputValidator/index.tsx";
import React, { memo, useCallback, useMemo, useState } from 'react';
import { Stack, VStack } from '@adc/parallax-component-library';
import { InputErrorField, InputPassword, PasswordRequirements } from 'Components/utility';
const PasswordInputValidator = /*#__PURE__*/memo(({
  placeholder,
  label,
  handleBlur,
  onChangeText,
  password,
  onValidate,
  errors,
  touched,
  passwordRules = [],
  testID,
  disabled
}) => {
  const [isBlurred, setIsBlurred] = useState(false);
  const [meetsPasswordRequirements, setMeetsPasswordRequirements] = useState(false);
  const onFocus = useCallback(() => {
    setIsBlurred(false);
  }, []);
  const filteredIdentities = useMemo(() => {
    const keysToFilter = ['min'];
    return passwordRules.filter(({
      data: {
        key
      }
    }) => keysToFilter.includes(key));
  }, [passwordRules]);
  const requirements = useMemo(() => {
    return filteredIdentities.map(({
      data,
      ...rest
    }) => {
      const match = new RegExp(data.regex).test(password.trim());
      const isInvalid = isBlurred && !match;
      return {
        match,
        isInvalid,
        data,
        ...rest
      };
    });
  }, [password, filteredIdentities, isBlurred]);
  const validatePassword = useCallback(() => {
    const remainingRequirements = requirements.filter(requirement => !requirement.match);
    const meetsPasswordRequirements = !remainingRequirements.length;
    setMeetsPasswordRequirements(meetsPasswordRequirements);
    onValidate && onValidate(meetsPasswordRequirements);
  }, [requirements, onValidate]);
  const onBlur = useCallback(e => {
    setIsBlurred(true);
    validatePassword();
    handleBlur(e);
  }, [handleBlur, validatePassword]);
  return /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InputPassword, {
    isInvalid: !meetsPasswordRequirements && isBlurred || (errors !== null && errors !== void 0 && errors[testID] && touched !== null && touched !== void 0 && touched[testID] ? true : false),
    placeholder: placeholder,
    label: label,
    testID: testID,
    onBlur: onBlur,
    onChangeText: onChangeText,
    defaultValue: password,
    onFocus: onFocus,
    disabled: disabled,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    marginTop: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(PasswordRequirements, {
    requirements: requirements,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 11
    }
  }), (errors === null || errors === void 0 ? void 0 : errors[testID]) && (touched === null || touched === void 0 ? void 0 : touched[testID]) && /*#__PURE__*/React.createElement(InputErrorField, {
    errorMessage: errors === null || errors === void 0 ? void 0 : errors[testID],
    testID: testID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 13
    }
  })));
});
PasswordInputValidator.displayName = 'PasswordInputValidator';
export { PasswordInputValidator };